<template>
  <div class="loss">
    <router-view></router-view>
    <img class="loss-icon" src="../../../assets/content-box.png"/>
  </div>
</template>

<script>
export default {
  name: 'Loss'
}
</script>

<style scoped>
  @import "Loss.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/loss/Loss.vue